import React, { useMemo, useRef, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { InsertImageUrlModal } from "../modals/insertImageUrlModal";

const RichTextEditor = ({ value, onChange, placeholder, title }) => {
  const quillRef = useRef(null);
  const savedRange = useRef(null);
  const [showImageModal, setShowImageModal] = useState(false);

  // Insert images by URL instead of embedding them as base64,
  // since email clients like Gmail strip base64 images.
  const handleInsertImage = (url) => {
    const editor = quillRef.current.getEditor();
    const index = savedRange.current?.index ?? editor.getLength();
    editor.insertEmbed(index, "image", url, "user");
    editor.setSelection(index + 1);
    setShowImageModal(false);
  };

  // Memoized so ReactQuill doesn't re-create the editor on every render
  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          ["bold", "italic", "underline", "strike"],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ color: [] }, { background: [] }],
          [{ align: [] }],
          ["link", "image"],
          ["clean"],
        ],
        handlers: {
          image: function () {
            // Remember the cursor position, since focus moves to the modal
            savedRange.current = this.quill.getSelection(true);
            setShowImageModal(true);
          },
        },
      },
    }),
    []
  );

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "color",
    "background",
    "align",
    "link",
    "image",
  ];

  return (
    <div>
      {title && (
        <label className="block text-sm font-medium text-[#151515] dark:text-white mb-2">
          {title}
        </label>
      )}
      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        className="bg-white dark:bg-[#121212] rounded-sm [&_.ql-editor]:min-h-[120px]"
      />
      <InsertImageUrlModal
        show={showImageModal}
        onClose={() => setShowImageModal(false)}
        onInsert={handleInsertImage}
      />
    </div>
  );
};

export default RichTextEditor;
